import { z } from 'zod';

import memorizedFetch from 'utils/memorized-fetch';

const COUNTRY_STORAGE_KEY = 'snt:geo:user_country';

export default async () => {
  let region = localStorage.getItem(COUNTRY_STORAGE_KEY);

  if (region) {
    return region;
  }

  const data = await memorizedFetch('https://get.geojs.io/v1/ip/country.json').then((body) =>
    body.json(),
  );

  region = z.object({ country: z.string() }).parse(data).country;

  localStorage.setItem(COUNTRY_STORAGE_KEY, region);

  return region;
};
